import * as A from "@radix-ui/react-accordion";
import { Plus } from "lucide-react";

export const Faq = ({ items, testid = "faq-list" }) => (
  <A.Root type="single" collapsible className="divide-y divide-gold/10 border-y hairline" data-testid={testid}>
    {items.map((f, i) => (
      <A.Item key={f.q} value={`q${i}`} data-testid={`faq-item-${i}`}>
        <A.Header>
          <A.Trigger
            data-testid={`faq-trigger-${i}`}
            className="group flex w-full items-start justify-between gap-6 py-6 text-left text-lg sm:text-xl font-medium tracking-tight text-paper hover:text-gold transition-colors"
          >
            <span className="flex gap-5">
              <span className="mt-1 font-mono text-xs text-gold">{String(i + 1).padStart(2, "0")}</span>
              {f.q}
            </span>
            <Plus className="mt-1 h-5 w-5 shrink-0 text-gold transition-transform duration-300 group-data-[state=open]:rotate-45" aria-hidden="true" />
          </A.Trigger>
        </A.Header>
        <A.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
          <p className="max-w-3xl pb-7 pl-10 text-base leading-relaxed text-mist">{f.a}</p>
        </A.Content>
      </A.Item>
    ))}
  </A.Root>
);
